export default class  Group {
    public id: string = "";
    public name: string = "";
    public userCount: number = 0;
}